import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { BigNumberWidgetOptions } from '../../../../widget-big-number/widget-big-number.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class BigNumberSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<BigNumberWidgetOptions>) {
    const getOptionForPoint = ((fieldOnePayload, fieldTwoPayload) => (point, option) =>
      point.custom.payloadIndex === 0 ? fieldOnePayload[option] : fieldTwoPayload[option])(
      {
        scoringStrategy: widget.payload.scoringStrategy ?? 'AVERAGE',
        boxDirection: widget.payload.boxDirection,
        boxSize: widget.payload.boxSize,
        scoreRange: widget.payload.scoreRange,
        analyticItem: widget.payload.analyticItem,
      },
      {
        scoringStrategy: widget.payload.scoringStrategyTwo ?? 'AVERAGE',
        boxDirection: widget.payload.boxDirectionTwo,
        boxSize: widget.payload.boxSizeTwo,
        scoreRange: widget.payload.scoreRangeTwo,
        analyticItem: widget.payload.analyticItemTwo,
      }
    );

    return selectedPoints
      .flatMap((p) => p)
      .map((p, idx) => {
        const analyticItem = getOptionForPoint(p, 'analyticItem');
        const scoring =
          analyticItem === 'documents' ? 'COUNT' : getOptionForPoint(p, 'scoringStrategy');
        const boxDirection = getOptionForPoint(p, 'boxDirection');
        const boxSize = getOptionForPoint(p, 'boxSize');

        let translationKey = `widgets.ai-insights.summary.${widget.payload.type}.${scoring}`;

        if (scoring === 'BOX') {
          translationKey = `${translationKey}.${boxDirection}`;
        }

        translationKey = `${translationKey}.${idx === 0 ? 'first-point' : 'rest-of-points'}`;
        if (idx === 0) {
          translationKey = `${translationKey}.${
            p.series.name ? 'has-comparison' : 'no-comparison'
          }`;
        }

        return {
          translationKey,
          translationParams: {
            boxSize,
            fieldName: FieldService.getFieldShortName(p.name),
            fieldValue: p.series.name,
            score: Utils.round(p.y),
          },
        };
      });
  }
}
